<!--{{acordosExistentes | json}}-->

<div class="container">
  <div class="row">
    <div class="col-12 info-text">
      <mat-icon aria-label="Erro">error</mat-icon>
      <span>{{msgAcordosExistentes}}</span>
    </div>
  </div>
  <div class="table-container" >

    <table class="data-table">
      <thead>
      <tr>
        <th>Código AEP</th>

        <th>Código Frota</th>
        <th>Nome da Frota</th>
        <th>Data da Proposta</th>
        <th>Status do Acordo</th>
        <th>Combustível</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let acordo of acordosExistentes; index as i; first as isFirst">
        <td>
          <span class="codigo-aep">{{acordo.codigoAEP}}</span>
        </td>

        <td>{{acordo.codigoFrota}}</td>
        <td>
          <strong>{{acordo.nomeFrota}}</strong>
        </td>
        <td>
          <span class="data-proposta">{{acordo.dataProposta | date: "dd/MM/yyyy"}}</span>
        </td>
        <td>
          <span class="status-chip" ng-class="getStatusClass(acordo.statusAcordo)">
            {{acordo.statusAcordo}}
          </span>
        </td>
        <td>
          <span class="combustivel-chip" ng-class="getCombustivelClass(proposta.indCombustivel)">
            {{pegarNomeCombustivel(acordo.indCombustivel)}}
          </span>
        </td>

      </tr>

      </tbody>
    </table>
  </div>

</div>

